import {
  PodborkaFindByUrlRequest,
  PodborkaFindByUrlResponse,
  ProductFindAllRequest,
  ProductFindAllResponse,
  PRODUCTS_ALL,
  PRODUCTS_PODBORKA_URL,
  PRODUCTS_USLUGA_URL,
  UslugaFindByUrlRequest,
  UslugaFindByUrlResponse,
} from "@project/shared-types";
import apiFetchPost from '../../../api/apiClient';

export const GetProductsAllAPI = async (dataRequest: ProductFindAllRequest) => {
  const response = await apiFetchPost<
    ProductFindAllRequest,
    ProductFindAllResponse
  >(PRODUCTS_ALL, dataRequest);
  return response;
};

export const GetProductByServiceUrlAPI = async (
  dataRequest: UslugaFindByUrlRequest
) => {
  const response = await apiFetchPost<
    UslugaFindByUrlRequest,
    UslugaFindByUrlResponse
  >(PRODUCTS_USLUGA_URL, dataRequest);
  return response;
};

export const GetPodborkaByUrlAPI = async (
  dataRequest: PodborkaFindByUrlRequest
) => {
  const response = await apiFetchPost<
    PodborkaFindByUrlRequest,
    PodborkaFindByUrlResponse
  >(PRODUCTS_PODBORKA_URL, dataRequest);
  return response;
};
